import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import {
  fetchSolicitacoesPorStatus,
  aceitarSolicitacao,
  negarSolicitacao,
} from "../../api/apiService";
import styles from "../../styles/SolicitacoesList.module.css";
import Navbar from "../../components/Navbar";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LinkGeneratorModal from "../../components/LinkGenerator";
import { Button, Typography, Box, TextField, Modal } from "@mui/material";
import FichaPaciente from "../../components/FichaPaciente";
import Filters from "../../components/SolicitacaoList/Filters";
import SolicitacaoItem from "../../components/SolicitacaoList/SolicitacaoItem";

function SolicitacoesList() {
  const [statusSelecionado, setStatusSelecionado] = useState("PENDENTE");
  const [categoriaSelecionada, setCategoriaSelecionada] = useState("");
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [expandedUsers, setExpandedUsers] = useState({});
  const [expandedId, setExpandedId] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedSolicitacao, setSelectedSolicitacao] = useState(null);
  const [popupType, setPopupType] = useState("");
  const [observacao, setObservacao] = useState("");
  const [dataConclusao, setDataConclusao] = useState("");
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [isImageFullscreen, setIsImageFullscreen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [subcategorias, setSubcategorias] = useState([]);
  const [subcategoriasSelecionadas, setSubcategoriasSelecionadas] = useState(
    []
  );
  const [isFiltroPopupOpen, setIsFiltroPopupOpen] = useState(false);
  const [termoPesquisa, setTermoPesquisa] = useState("");
  const [observacaoDetalhada, setObservacaoDetalhada] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [dataInicial, setDataInicial] = useState(() => {
    const hoje = new Date();
    const trintaDiasAntes = new Date();
    trintaDiasAntes.setDate(hoje.getDate() - 30);
    return trintaDiasAntes.toISOString().split("T")[0];
  });
  const [dataFinal, setDataFinal] = useState(() => {
    const hoje = new Date();
    return hoje.toISOString().split("T")[0];
  });
  const [isDateFilterOpen, setIsDateFilterOpen] = useState(false);
  const [dataInicialTemp, setDataInicialTemp] = useState(dataInicial);
  const [dataFinalTemp, setDataFinalTemp] = useState(dataFinal);
  const [isGenerateLinkModalOpen, setIsGenerateLinkModalOpen] = useState(false);
  const [currentSolicitacaoId, setCurrentSolicitacaoId] = useState(null);
  const [isFichaPacienteModalOpen, setIsFichaPacienteModalOpen] =
    useState(false);
  const [isFichaPacienteButtonDisabled, setIsFichaPacienteButtonDisabled] =
    useState(false);
  const [selectedCpf, setSelectedCpf] = useState(null);
  const [pressed, setPressed] = useState(null);
  const touchHandledRef = useRef(false); // 🔹 Ref para evitar clique duplo no mobile

  useEffect(() => {
    if (isGenerateLinkModalOpen || isPopupOpen || isDateFilterOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [isGenerateLinkModalOpen, isPopupOpen, isDateFilterOpen]);

  useEffect(() => {
    if (isFichaPacienteModalOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [isFichaPacienteModalOpen]);

  const openGenerateLinkModal = (solicitacaoId) => {
    setCurrentSolicitacaoId(solicitacaoId);
    setIsGenerateLinkModalOpen(true);
  };

  const closeGenerateLinkModal = () => {
    setCurrentSolicitacaoId(null);
    setIsGenerateLinkModalOpen(false);
  };

  const openFichaModal = (cpf) => {
    if (!isFichaPacienteModalOpen) {
      setSelectedCpf(cpf);
      setIsFichaPacienteButtonDisabled(true);
      setIsFichaPacienteModalOpen(true);
      setTimeout(() => setIsFichaPacienteButtonDisabled(false), 500);
    }
  };

  const closeFichaModal = () => {
    setIsFichaPacienteModalOpen(false);
    setSelectedCpf(null);
  };

  const confirmarFiltroData = () => {
    setDataInicial(dataInicialTemp);
    setDataFinal(dataFinalTemp);
    aplicarFiltroData();
  };

  const handlePressStart = (userName) => {
    setPressed(userName);
    touchHandledRef.current = false;
  };

  const handlePressEnd = (userName) => {
    setPressed(null);
    if (!touchHandledRef.current) {
      toggleUserExpand(userName);
    }
  };

  const handleTouchEnd = (userName) => {
    touchHandledRef.current = true;
    handlePressEnd(userName);
  };

  useEffect(() => {
    if (categoriaSelecionada) {
      const todasSolicitacoes = Object.values(solicitacoes || {}).flat();

      const subcategoriasFiltradas = todasSolicitacoes
        .filter((sol) => sol.categoriaServico === categoriaSelecionada)
        .map((sol) => sol.nomeServico)
        .filter((value, index, self) => self.indexOf(value) === index);

      setSubcategorias(subcategoriasFiltradas);

      setSubcategoriasSelecionadas((prev) =>
        prev.filter((sub) => subcategoriasFiltradas.includes(sub))
      );
    } else {
      setSubcategorias([]);
      setSubcategoriasSelecionadas([]);
    }
  }, [categoriaSelecionada, solicitacoes]);

  const openFullscreenImage = (url) => {
    setImageUrl(url);
    setIsImageFullscreen(true);
  };

  const closeFullscreenImage = () => {
    setIsImageFullscreen(false);
    setImageUrl("");
  };

  const nome = localStorage.getItem("nome");

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("loggedIn");
    if (isLoggedIn) {
      toast.success(
        `Bem-vindo, ${
          nome ? nome.split(" ").slice(0, 2).join(" ") : "Usuário"
        }!`,
        {
          position: "bottom-center",
          autoClose: 2000,
        }
      );
      localStorage.removeItem("loggedIn");
    }
  }, [nome]);

  useEffect(() => {
    const getSolicitacoes = async () => {
      setLoading(true);

      try {
        const data = await fetchSolicitacoesPorStatus(
          statusSelecionado,
          dataInicial,
          dataFinal,
          currentPage - 1,
          50
        );

        setSolicitacoes(data.groups || {});
        setTotalPages(data.totalPages || 1);
      } catch (err) {
        console.error("Erro ao carregar as solicitações:", err);
        toast.error("Erro ao carregar solicitações. Tente novamente.");
      } finally {
        setLoading(false);
      }
    };

    getSolicitacoes();
  }, [statusSelecionado, currentPage, dataInicial, dataFinal]);

  const toggleUserExpand = useCallback((userName) => {
    setExpandedUsers((prev) => ({
      ...prev,
      [userName]: !prev[userName],
    }));
  }, []);

  const aplicarFiltroData = async () => {
    if (
      dataInicial &&
      dataFinal &&
      new Date(dataInicial) > new Date(dataFinal)
    ) {
      toast.error("A data de início não pode ser maior que a data de fim.");
      return;
    }

    setCurrentPage(1);

    try {
      setLoading(true);
      const sort =
        statusSelecionado === "PENDENTE" ? "ascending" : "descending";

      const data = await fetchSolicitacoesPorStatus(
        statusSelecionado,
        dataInicial || null,
        dataFinal || null,
        0,
        50,
        sort
      );

      setSolicitacoes(data.groups || {});
      setTotalPages(data.totalPages || 1);
      setIsDateFilterOpen(false);
    } catch (err) {
      console.error("Erro ao carregar as solicitações:", err);
      toast.error("Erro ao carregar solicitações. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  const toggleExpand = useCallback((id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  }, []);

  const openPopup = (solicitacao, type) => {
    setSelectedSolicitacao(solicitacao);
    setPopupType(type);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setObservacao("");
    setDataConclusao("");
  };

  const handleAccept = async () => {
    try {
      setActionLoading(true);
      const observacaoFinal =
        observacao === "Outros" && observacaoDetalhada
          ? `Outros: ${observacaoDetalhada}`
          : observacao;

      await aceitarSolicitacao(
        selectedSolicitacao.id,
        observacaoFinal,
        dataConclusao
      );

      setSolicitacoes((prev) => {
        const updated = { ...prev };

        Object.keys(updated).forEach((key) => {
          updated[key] = updated[key].filter(
            (sol) => sol.id !== selectedSolicitacao.id
          );

          if (updated[key].length === 0) {
            delete updated[key];
          }
        });

        return updated;
      });

      toast.success("Solicitação aceita com sucesso!");
      closePopup();
    } catch (err) {
      console.error("Erro ao aceitar solicitação:", err);
      toast.error("Erro ao aceitar solicitação.");
    } finally {
      setActionLoading(false);
    }
  };

  const handleDeny = async () => {
    try {
      setActionLoading(true);
      const observacaoFinal =
        observacao === "Outros" && observacaoDetalhada
          ? `Outros: ${observacaoDetalhada}`
          : observacao;

      await negarSolicitacao(selectedSolicitacao.id, observacaoFinal);

      setSolicitacoes((prev) => {
        const updated = { ...prev };

        Object.keys(updated).forEach((key) => {
          updated[key] = updated[key].filter(
            (sol) => sol.id !== selectedSolicitacao.id
          );

          if (updated[key].length === 0) {
            delete updated[key];
          }
        });

        return updated;
      });

      toast.success("Solicitação negada com sucesso!");
      closePopup();
    } catch (err) {
      console.error("Erro ao negar solicitação:", err);
      toast.error("Erro ao negar solicitação.");
    } finally {
      setActionLoading(false);
    }
  };

  const handleWhatsappClick = (nome, telefone, nomeServico, protocolo) => {
    const mensagem = `Olá *${
      nome.split(" ")[0]
    }*, Tudo bem? 😊%0A%0AEstou entrando em contato sobre sua solicitação de *${nomeServico}* com o protocolo *${protocolo}*.%0A_Se precisar de mais informações ou assistência, estou à disposição!_`;

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const whatsappUrl = isMobile
      ? `https://api.whatsapp.com/send?phone=55${telefone}&text=${mensagem}`
      : `https://web.whatsapp.com/send?phone=55${telefone}&text=${mensagem}`;

    window.open(whatsappUrl, "_blank");
  };

  function calcularDiasUteis(dataInicio, dataAtual) {
    const feriados = [
      "2025-01-01", // Confraternização Universal
      "2025-02-28", // Carnaval (ponto facultativo)
      "2025-03-01", // Carnaval (ponto facultativo)
      "2025-03-05", // Quarta-feira de Cinzas (ponto facultativo até 12h)
      "2025-04-18", // Sexta-feira Santa (Paixão de Cristo)
      "2025-04-21", // Tiradentes
      "2025-05-01", // Dia do Trabalho
      "2025-06-19", // Corpus Christi (ponto facultativo)
      "2025-09-07", // Independência do Brasil
      "2025-10-12", // Nossa Senhora Aparecida
      "2025-11-02", // Finados
      "2025-11-15", // Proclamação da República
      "2025-12-25", // Natal
    ];

    let inicio = new Date(dataInicio);
    let fim = new Date(dataAtual);
    let diasUteis = 0;

    inicio.setHours(0, 0, 0, 0);
    fim.setHours(0, 0, 0, 0);

    while (inicio < fim) {
      const diaSemana = inicio.getDay();
      const dataFormatada = inicio.toISOString().split("T")[0];

      if (diaSemana > 0 && diaSemana < 6 && !feriados.includes(dataFormatada)) {
        diasUteis++;
      }
      inicio.setDate(inicio.getDate() + 1);
    }

    return diasUteis;
  }

  const solicitacoesFiltradas = useMemo(() => {
    const todasSolicitacoes = Object.entries(solicitacoes).flatMap(
      ([userName, itens]) => itens.map((item) => ({ ...item, userName }))
    );

    return todasSolicitacoes.filter((sol) => {
      if (
        categoriaSelecionada &&
        sol.categoriaServico !== categoriaSelecionada
      ) {
        return false;
      }

      if (
        subcategoriasSelecionadas.length > 0 &&
        !subcategoriasSelecionadas.includes(sol.nomeServico)
      ) {
        return false;
      }

      // Filtro por termo de pesquisa (nome, protocolo, serviço)
      if (
        termoPesquisa &&
        ![sol.nomeServico, sol.protocolo, sol.solicitante]
          .join(" ")
          .toLowerCase()
          .includes(termoPesquisa.toLowerCase())
      ) {
        return false;
      }

      return true;
    });
  }, [
    solicitacoes,
    categoriaSelecionada,
    subcategoriasSelecionadas,
    termoPesquisa,
  ]);
  const solicitacoesAgrupadas = useMemo(() => {
    return solicitacoesFiltradas.reduce((groups, sol) => {
      if (!groups[sol.userName]) {
        groups[sol.userName] = [];
      }
      groups[sol.userName].push(sol);
      return groups;
    }, {});
  }, [solicitacoesFiltradas]);

  return (
    <Box
      sx={{
        bgcolor: "#f5f5f5",
        minHeight: "100vh",
        paddingTop: 5,
        paddingLeft: 2,
        paddingRight: 2,
        paddingBottom: 3,
        marginTop: "7vh",
        "@media (max-width: 720px)": {
          marginTop: "5vh",
          paddingTop: 5,
        },
      }}
    >
      <Box
        sx={{
          bgcolor: "#fff",
          borderRadius: 2,
          p: 2,
          boxShadow: 3,
          maxWidth: "100vw",
          mx: "auto",
          "@media (max-width: 720px)": {
            p: 2,
          },
        }}
      >
        <Navbar />
        {/* Filtros Principais */}
        <Filters
          statusSelecionado={statusSelecionado}
          setStatusSelecionado={setStatusSelecionado}
          termoPesquisa={termoPesquisa}
          setTermoPesquisa={setTermoPesquisa}
          isDateFilterOpen={isDateFilterOpen}
          setIsDateFilterOpen={setIsDateFilterOpen}
          dataInicialTemp={dataInicialTemp}
          setDataInicialTemp={setDataInicialTemp}
          dataFinalTemp={dataFinalTemp}
          setDataFinalTemp={setDataFinalTemp}
          confirmarFiltroData={confirmarFiltroData}
          categoriaSelecionada={categoriaSelecionada}
          setCategoriaSelecionada={setCategoriaSelecionada}
          subcategorias={subcategorias}
          subcategoriasSelecionadas={subcategoriasSelecionadas}
          setSubcategoriasSelecionadas={setSubcategoriasSelecionadas}
          isFiltroPopupOpen={isFiltroPopupOpen}
          setIsFiltroPopupOpen={setIsFiltroPopupOpen}
        />

        {loading ? (
          <div className={styles.loadingContainer}>
            <ClipLoader color="#007bff" size={30} />
            <p>Carregando...</p>
          </div>
        ) : (
          <ul className={styles.solicitacoesList}>
            {Object.entries(solicitacoesAgrupadas).map(([userName, itens]) => {
              const solicitacoesOrdenadas = itens.sort(
                (a, b) =>
                  new Date(a.dataSolicitacao) - new Date(b.dataSolicitacao)
              );

              const possuiItensComMaisDe48h = solicitacoesOrdenadas.some(
                (sol) => {
                  const diasUteis = calcularDiasUteis(
                    sol.dataSolicitacao,
                    new Date()
                  );
                  return sol.status === "PENDENTE" && diasUteis > 2;
                }
              );

              return (
                <Box
                  key={userName}
                  sx={{
                    mb: 1,
                    p: 1.5,
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    boxShadow: 1,
                    animation: "fadeIn 0.5s ease-in-out",
                  }}
                >
                  {/* Cabeçalho do Usuário */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      transition: "transform 0.15s ease-in-out",
                      transform:
                        pressed === userName ? "scale(0.97)" : "scale(1)",
                    }}
                    onMouseDown={() => handlePressStart(userName)}
                    onMouseUp={() => handlePressEnd(userName)}
                    onTouchStart={() => handlePressStart(userName)}
                    onTouchEnd={() => handleTouchEnd(userName)}
                  >
                    <Typography variant="h6">
                      {userName.split("-")[0].trim()}
                    </Typography>
                    {possuiItensComMaisDe48h && (
                      <Typography
                        sx={{
                          color: "error.main",
                          fontSize: "0.875rem",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        ⚠️ Solicitações com 48h+
                      </Typography>
                    )}
                  </Box>

                  {expandedUsers[userName] &&
                    solicitacoesOrdenadas.map((solicitacao) => (
                      <SolicitacaoItem
                        key={solicitacao.id}
                        solicitacao={solicitacao}
                        expandedId={expandedId}
                        toggleExpand={toggleExpand}
                        statusSelecionado={statusSelecionado}
                        diasUteis={calcularDiasUteis(
                          solicitacao.dataSolicitacao,
                          new Date()
                        )}
                        openGenerateLinkModal={openGenerateLinkModal}
                        openPopup={openPopup}
                        openFichaModal={openFichaModal}
                        handleWhatsappClick={handleWhatsappClick}
                        openFullscreenImage={openFullscreenImage}
                        isFichaPacienteButtonDisabled={
                          isFichaPacienteButtonDisabled
                        }
                        userName={userName}
                      />
                    ))}
                </Box>
              );
            })}
          </ul>
        )}

        {isPopupOpen && (
          <Modal
            open={isPopupOpen}
            onClose={closePopup}
            sx={{
              "& .MuiBackdrop-root": {
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(4px)", // Adiciona um efeito de desfoque
              },
              "& .MuiPaper-root": {
                animation: "fadeInUp 0.4s ease-in-out",
              },
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "background.paper",
                p: 4,
                borderRadius: 2,
                boxShadow: 24,
                width: "90%",
                maxWidth: 400,
              }}
            >
              <Typography variant="h6" gutterBottom>
                {`Solicitação: ${selectedSolicitacao.nomeServico}`}
              </Typography>

              {actionLoading ? (
                <Box sx={{ textAlign: "center" }}>
                  <ClipLoader color="#007bff" size={30} />
                  <Typography>Processando...</Typography>
                </Box>
              ) : (
                <>
                  {popupType === "ACEITAR" && (
                    <>
                      <TextField
                        label="Data de Conclusão*"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        value={dataConclusao}
                        onChange={(e) => setDataConclusao(e.target.value)}
                        fullWidth
                        sx={{ mb: 3 }}
                        required
                      />
                      <TextField
                        label="Observação"
                        select
                        SelectProps={{ native: true }}
                        value={observacao}
                        onChange={(e) => {
                          const value = e.target.value;
                          setObservacao(value);
                          if (value !== "Outros") setObservacaoDetalhada("");
                        }}
                        fullWidth
                        sx={{ mb: 3 }}
                        required
                      >
                        <option value=""></option>
                        <option value="Critérios atendidos">
                          Critérios atendidos
                        </option>
                        <option value="Emergência médica">
                          Emergência médica
                        </option>
                        <option value="Vaga disponível">Vaga disponível</option>
                        <option value="Pedido com prioridade">
                          Pedido com prioridade
                        </option>
                        <option value="Solicitação bem fundamentada">
                          Solicitação bem fundamentada
                        </option>
                        <option value="Indicação médica clara">
                          Indicação médica clara
                        </option>
                        <option value="Demanda alinhada ao perfil da unidade">
                          Demanda alinhada ao perfil da unidade
                        </option>
                        <option value="Outros">Outros</option>
                      </TextField>
                      {observacao === "Outros" && (
                        <TextField
                          label="Detalhe a Observação"
                          value={observacaoDetalhada}
                          onChange={(e) =>
                            setObservacaoDetalhada(e.target.value)
                          }
                          placeholder="Digite sua observação..."
                          fullWidth
                          multiline
                          rows={4}
                          sx={{ mb: 3 }}
                          required
                        />
                      )}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="success"
                          onClick={handleAccept}
                          disabled={
                            !dataConclusao ||
                            (observacao === "Outros" && !observacaoDetalhada)
                          }
                        >
                          Confirmar
                        </Button>
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={closePopup}
                        >
                          Cancelar
                        </Button>
                      </Box>
                    </>
                  )}

                  {popupType === "NEGAR" && (
                    <>
                      <TextField
                        label="Observação*"
                        select
                        SelectProps={{ native: true }}
                        value={observacao}
                        onChange={(e) => {
                          const value = e.target.value;
                          setObservacao(value);
                          if (value !== "Outros") setObservacaoDetalhada("");
                        }}
                        fullWidth
                        sx={{ mb: 3 }}
                        required
                      >
                        <option value=""></option>
                        <option value="Ficha incompleta">
                          Ficha incompleta
                        </option>
                        <option value="Dados pessoais desatualizados">
                          Dados pessoais desatualizados
                        </option>
                        <option value="Critérios clínicos não atendidos">
                          Critérios clínicos não atendidos
                        </option>
                        <option value="Especialidade incompatível com a solicitação">
                          Especialidade incompatível com a solicitação
                        </option>
                        <option value="Solicitação duplicada">
                          Solicitação duplicada
                        </option>
                        <option value="Falta de indicação médica">
                          Falta de indicação médica
                        </option>
                        <option value="Paciente não compareceu à consulta anterior">
                          Paciente não compareceu à consulta anterior
                        </option>
                        <option value="Capacidade de atendimento excedida">
                          Capacidade de atendimento excedida
                        </option>
                        <option value="Necessidade de avaliação prévia na atenção básica">
                          Necessidade de avaliação prévia na atenção básica
                        </option>
                        <option value="Outros">Outros</option>
                      </TextField>
                      {observacao === "Outros" && (
                        <TextField
                          label="Detalhe o Motivo"
                          value={observacaoDetalhada}
                          onChange={(e) =>
                            setObservacaoDetalhada(e.target.value)
                          }
                          placeholder="Digite o motivo..."
                          fullWidth
                          multiline
                          rows={4}
                          sx={{ mb: 3 }}
                          required
                        />
                      )}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="error"
                          onClick={handleDeny}
                          disabled={
                            !observacao ||
                            (observacao === "Outros" && !observacaoDetalhada)
                          }
                        >
                          Confirmar
                        </Button>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={closePopup}
                        >
                          Cancelar
                        </Button>
                      </Box>
                    </>
                  )}
                </>
              )}
            </Box>
          </Modal>
        )}
      </Box>
      {isImageFullscreen && (
        <div
          className={styles.fullscreenOverlay}
          onClick={closeFullscreenImage}
        >
          <div
            className={styles.fullscreenContent}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.fullscreenBody}>
              <img
                src={imageUrl}
                alt="Imagem da solicitação"
                className={styles.fullscreenImage}
              />
            </div>
          </div>
        </div>
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
          mt: 4,
        }}
      >
        <Button
          variant="outlined"
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          sx={{
            transition: "transform 0.2s ease-in-out",
            "&:hover": {
              transform: "scale(1.05)",
            },
          }}
        >
          Anterior
        </Button>

        <Button
          variant="outlined"
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
          sx={{
            transition: "transform 0.2s ease-in-out",
            "&:hover": {
              transform: "scale(1.05)",
            },
          }}
        >
          Próxima
        </Button>
      </Box>
      <LinkGeneratorModal
        isOpen={isGenerateLinkModalOpen}
        onClose={closeGenerateLinkModal}
        solicitacaoId={currentSolicitacaoId}
      />
      <FichaPaciente
        isOpen={isFichaPacienteModalOpen}
        onClose={closeFichaModal}
        cpf={selectedCpf}
      />
    </Box>
  );
}

export default SolicitacoesList;
